import React from "react";
import { Badge } from "components/ui/badge";
import { Spinner } from "components/ui/spinner";

/**
 * Reusable loading badge with spinner (always centered).
 *
 * @param {string} [label] - Text to display (defaults to "Syncing")
 */
export default function SyncingBadge({ label = "Syncing" }) {
  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 100
    }}>
      <Badge>
        <Spinner />
        {label}
      </Badge>
    </div>
  );
}
